<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <app-menu-product-sub-menu [active]="'detail'" [product]="productsDetail"></app-menu-product-sub-menu>

    <div class="exhibitor-backoffice__content" *ngIf="loader.count === 0">

      <div class="action-buttons-container">
        <button type="button" (click)="goTo(buttonLink)" class="btn" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'EXHIBITOR_BACKOFFICE_PRODUCT_DETAIL.EDIT_PRODUCT' | translate }}</button>
      </div>

      <div class="detail-content">

        <div class="detail-content__left">
            <div class="detail-image-container">
              <div class="detail-image-gallery">
                <div class="detail-image-gallery__item pointer" [ngClass]="{'gallery-item--active': image?.id === activeImage?.id }" *ngFor="let image of images" (click)="setActiveImage(image)">
                  <img [src]="setImage(image.url)" alt="image-{{ image.id }}" width="80" height="122" />
                </div>
              </div>
              <div class="detail-image-active">
                <img [src]="setImage(activeImage?.url)" alt="image-{{ activeImage?.id }}" width="482" height="723" />
              </div>
            </div>
            <div class="detail-content__categories" *ngIf="!isEmpty(productCategories?.hierarchicalProperties) || !isEmpty(productCategories?.masterProperties)">
              <ng-container *ngIf="unifiedCategories?.length > 0">{{ 'CARD_DETAIL.LOCATE_ON_MAP' | translate }}</ng-container>
              <div class="categories-container">
                <div class="category-item" *ngFor="let category of unifiedCategories">
                  <span>{{_api(category.translations, 'name')}}</span>
                </div>
              </div>

            </div>
        </div>

        <div class="detail-content__right">

          <div class="detail-content__pre-title">
            {{ projection?.name }}
          </div>

          <div class="detail-content__title">
            {{_api(productsDetail['translations'], 'name')}}
          </div>
          <app-detail-description [projection]="productsDetail"></app-detail-description>
          <app-detail-files [files]="files"></app-detail-files>
          <app-detail-video [projection]="productsDetail" width="100%" height="238"></app-detail-video>

          <h3>{{ 'CARD_DETAIL.EXHIBITOR' | translate }}</h3>
          <!--<h3 class="bold title">{{_('exhibitor', 'exhibitor')}}</h3>-->
          <div class="exhibitor-location" *ngIf="catalogueService.getProperty('mapsActive') && detailsService.getPropertyByKey('maps.firamaps.enabled')">
            <div class="detail-map__item pointer" routerLink="/{{catalogueService.getProperty('eventName')}}/firamaps" [queryParams]="{ exhibitorId: exhibitorId }">
              <img class="pointer" width="18" height="18" [alt]="'GO_MAP' | translate" src="assets/img/place_grey.svg">
              <span>{{ 'CARD_DETAIL.LOCATE_ON_MAP' | translate }} </span>
            </div>
          </div>
          <div *ngIf="projection?.standLocation">
            <app-stand-display [standData]="projection?.standLocation"></app-stand-display>
          </div>

          <div class="detail-contact">
            <div class="image pointer" (click)="goExibitors()">
              <!--<exhibitor-images [images]="[{url: setExhibitorImage(exhibitorMainImage)}]"></exhibitor-images>-->
              <img [src]="imageUrl?.data" class="carouselImage" alt="A slide">
            </div>

            <div class="detail-contact-right">
              <div class="detail-content__name">
                {{ projection?.name }}
              </div>

              <div class="detail-contact__item detail-contact__item--underline" *ngIf="projection?.webSite">
                <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/language.svg">
                <a [href]="fixUrl(projection?.webSite)" target="_blank">{{ fixUrl(projection?.webSite) }}</a>
              </div>
              <div class="detail-contact__item" *ngIf="projection?.addressLine2 || projection?.zipCode || projection?.city">
                <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/place_red.svg">
                <div class="">
                  <span class="text">
                    <span>{{projection?.addressLine1}}</span>
                    <span *ngIf="projection?.addressLine2">&nbsp;{{projection?.addressLine2}}</span>
                    <span *ngIf="projection?.zipCode">, {{projection?.zipCode}}</span>
                    <span *ngIf="projection?.city">, {{projection?.city}}</span>
                  </span>
                </div>
              </div>
              <div class="detail-contact__item" *ngIf="projection?.contactTelephone">
                <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/call.svg">
                <div class="">{{ projection?.contactTelephone }}</div>
              </div>
              <div class="detail-contact__item" *ngIf="exhibitorHasSocialNetworks(projection)">
                <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/rss_feed.svg">
                <div class="social-links">
                  <social-networks-links [exhibitor]="projection" [socialNetworks]="socialNetworks"></social-networks-links>
                </div>
              </div>
            </div>
          </div>

        </div>



      </div>
    </div>

    <app-footer></app-footer>
